export default __webpack_public_path__ + "static/media/logo.627550f1.svg";